export default function decodeAuthenticationToken(cookieAuthenticationToken) {
  try {
    return JSON.parse(atob(cookieAuthenticationToken.split('.')[1]));
  } catch (error) {
    console.error(error);
    return null;
  }
};
